export const modifyReviewRequested = (inci, data) => {
  if (inci.nf_ingredient && inci.nf_ingredient_id === data.id) {
    inci.nf_ingredient.is_requested_review = data.is_requested_review;
  }
  return inci;
}
